import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { StatusLocKey } from '../../state';
import { HeaderTooltip } from '@bonanza-social/moonlight';
import { StatusUpdateTooltipProps } from './StatusUpdateTooltip.types';

function StatusUpdateTooltip({ status }: StatusUpdateTooltipProps) {
  const claimedBoxesCount = status?.claimedBoxesCount;
  const prevClaimedBoxesCount = useRef(claimedBoxesCount);

  const playerStatus = status.playerStatus;
  const prevPlayerStatus = useRef(playerStatus);

  const [tooltipLocKey, setTooltipLocKey] = useState<StatusLocKey>();

  useEffect(() => {
    if (
      claimedBoxesCount === undefined ||
      prevClaimedBoxesCount.current === undefined ||
      playerStatus === undefined ||
      prevPlayerStatus === undefined
    ) {
      return;
    }

    const gemCollected = claimedBoxesCount > prevClaimedBoxesCount.current;
    const newStatus = playerStatus !== prevPlayerStatus.current;

    prevClaimedBoxesCount.current = claimedBoxesCount;
    prevPlayerStatus.current = playerStatus;

    if (newStatus) {
      setTooltipLocKey('statusHeaderNewStatus');
    } else if (gemCollected) {
      setTooltipLocKey('statusHeaderGemCollected');
    }
  }, [claimedBoxesCount, playerStatus]);

  const hideTooltip = useCallback(() => {
    setTooltipLocKey(undefined);
  }, []);

  return (
    <HeaderTooltip
      visible={Boolean(tooltipLocKey)}
      hide={hideTooltip}
      locNS="status"
      locKey={tooltipLocKey}
      gradient={`status${playerStatus}Background`}
    />
  );
}

export default memo(StatusUpdateTooltip);
